import React from 'react';
import { useQuery } from '@apollo/client';

import RootComponent from '../../../renderComponents/RootComponent/RootComponent';
import { returnValidJson } from '../../PageRenderer/PageRenderer';
import { GET_CMS_BLOCKS } from '../../../commonQueries';
import Loader from '../../Loader/Loader'
import './ProductDelivery.scss';

const ProductDelivery = () => {
  const { data, loading } = useQuery(GET_CMS_BLOCKS, {
    variables: {
      identifiers: 'shipping_price',
    },
    fetchPolicy: 'cache-first',
  });

  if (loading || !data) {
    return <Loader />;
  }

  const json = data && data.cmsBlocks.items[0].content_json && returnValidJson(data.cmsBlocks.items[0].content_json);

  if (!json && data) {
    const html = data.cmsBlocks.items[0].hydrated_content.replace(/#html-body/g, 'body');
    // TODO: it has HTML encoded content, it's currently broken
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return <div className="product-delivery">{data && <RootComponent children={json} />}</div>;
};

export default React.memo(ProductDelivery);
